export class TemplateRequest {
	primaryColor: string;
	secondColor: string;
	thirthColor: string;
	numberInvoice: number;
	isPreview: boolean = false;
	warehouseName: string;
	warehouseId: number;

	constructor(
		primaryColor: string,
		secondColor: string,
		thirthColor: string,
		numberInvoice: number,
		warehouseName: string,
		warehouseId: number) {
		this.primaryColor = primaryColor;
		this.secondColor = secondColor;
		this.thirthColor = thirthColor;
		this.numberInvoice = numberInvoice;
		this.warehouseName = warehouseName;
		this.warehouseId = warehouseId;
	}
}

export class ConfigurationPage {
	margin: ConfigurationMarginPage;
	startY: number;
}

export class ConfigurationMarginPage {
	top: number; 
	bottom: number;
	left: number;
	right: number;

	constructor(top: number, bottom: number, left: number, right: number){
		this.top = top;
		this.bottom = bottom;
		this.left = left;
		this.right = right
	}
}